import React from "react";
import Slider from "react-slick";
import { Container } from "reactstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./TestimonialsStrip.css";

const testimonials = [
  {
    text: "Reliable infrastructure and fast support. Exactly what we needed for our workloads.",
    attribution: "— Hosting Noodle customer",
  },
  {
    text: "The dedicated instance was set up quickly and the team helped us with every step. Great value.",
    attribution: "— Hosting Noodle customer",
  },
  {
    text: "We moved our processing to Noodle Cloud and haven't looked back. Uptime has been solid.",
    attribution: "— Hosting Noodle customer",
  },
  {
    text: "Professional deployment and clear communication. Our DevOp contact made the whole process smooth.",
    attribution: "— Hosting Noodle customer",
  },
  {
    text: "Support replies within a day and actually solves the issue. Refreshing compared to bigger providers.",
    attribution: "— Hosting Noodle customer",
  },
];

const TestimonialsStrip = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
  };

  return (
    <section className="hn-testimonials-strip">
      <Container>
        <Slider {...settings} className="hn-testimonials-slider">
          {testimonials.map((item, i) => (
            <div key={i} className="hn-testimonial-slide">
              <p className="hn-testimonials-text">
                <i className="fas fa-quote-left me-2" aria-hidden="true" />
                {item.text}
              </p>
              <p className="hn-testimonials-attribution">{item.attribution}</p>
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  );
};

export default TestimonialsStrip;
